/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const da_date = /** @type {(inputs: {}) => string} */ () => {
	return `Dato`
};

const de_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const en_date = /** @type {(inputs: {}) => string} */ () => {
	return `Date`
};

const es_date = /** @type {(inputs: {}) => string} */ () => {
	return `Fecha`
};

const fr_date = /** @type {(inputs: {}) => string} */ () => {
	return `Date`
};

const hu_date = /** @type {(inputs: {}) => string} */ () => {
	return `Dátum`
};

const it_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data`
};

const nl_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

const pl_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data`
};

const pt_date = /** @type {(inputs: {}) => string} */ () => {
	return `Data`
};

const sv_date = /** @type {(inputs: {}) => string} */ () => {
	return `Datum`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const date = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.date(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("date", locale)
	if (locale === "cs") return cs_date(inputs)
	if (locale === "da") return da_date(inputs)
	if (locale === "de") return de_date(inputs)
	if (locale === "en") return en_date(inputs)
	if (locale === "es") return es_date(inputs)
	if (locale === "fr") return fr_date(inputs)
	if (locale === "hu") return hu_date(inputs)
	if (locale === "it") return it_date(inputs)
	if (locale === "nl") return nl_date(inputs)
	if (locale === "pl") return pl_date(inputs)
	if (locale === "pt") return pt_date(inputs)
	return sv_date(inputs)
};